import { useQuery } from '@tanstack/react-query'
import { getProcurementPurchaseOrders } from 'api'
import { useFilter } from 'hooks/useFilter'
import { colors, H2 } from 'styling/GlobalStyles'

export const PurchaseOrdersHeader = () => {
  const { values } = useFilter()
  const { data } = useQuery({
    queryKey: ['procurement-purchase-orders', values],
    queryFn: () =>
      getProcurementPurchaseOrders({
        page: values.page,
        limit: values.limit,
      }),
  })
  return (
    <H2 noUpperCase>
      {data?.totalCount} total requests •{' '}
      <span style={{ color: colors.orange }}>{data?.data.length} Shown</span>
    </H2>
  )
}
